module.exports = __webpack_public_path__ + "img/robot.15fe7a3f.svg";